import { render } from "./JsonField.vue?vue&type=template&id=b212ffb4"
import script from "./JsonField.vue?vue&type=script&lang=js"
export * from "./JsonField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__